(ns frontend.ux-overhaul.listing.pipeline-entity.column-add
  "The button that adds an item to a column of the Kanban of a pipeline entity
   type. A column of a Kanban that is grouped by the stage has the id of a stage
   as its value. The button opens the creator of the entity type, with the stage
   of the column. The button follows the rules of the toolbar: the creation flow of
   the entity type must be on, the user must not be read only, and the creator
   config of the pipeline must allow the creation in the stage."
  (:require
   [common.localization :as loc]
   [frontend.page-components.navbar-components.create-dropdown :as create-dropdown]
   [frontend.state.current-session :as session]
   [frontend.view.entity :as entity]))

(defn column-stage
  "Return the stage that is the column with the value `column-value`, or nil. The
   value of a column that comes from the index is a string, and the id of a stage
   is a number, so the function compares the two as strings. Entity ids are
   unique, so a column of another field cannot match a stage."
  [{:keys [column-value stages]}]
  (when (some? column-value)
    (let [value (str column-value)]
      (->> stages
           (filter (fn [{:keys [db/id]}]
                     (= value (str id))))
           first))))

(defn add-item
  "Return a map with the `:label` and the `:on-click` of the button of a column,
   or nil when the column has no button. The label is the text of the key
   `label-key`, the same text as the button of the toolbar. The click opens the
   creator of the entity type, with the stage of the column, the same as the item
   of the stage in the toolbar."
  [{:keys [entity-type pipeline label-key column-value]}]
  (let [flow-fn (get entity/opportunity-flow-fns entity-type)]
    (when (and flow-fn
               (flow-fn)
               pipeline
               (not (session/is-read-only-user?)))
      (when-let [stage (column-stage
                        {:column-value column-value
                         :stages       (create-dropdown/creatable-stages
                                        {:entity-type entity-type
                                         :pipeline    pipeline})})]
        {:label    (loc/tr label-key)
         :on-click (:on-click (create-dropdown/pipeline-stage-item
                               {:entity-type entity-type
                                :pipeline    pipeline
                                :stage       stage}))}))))

(defn column-add-fn
  "Return the function of the Kanban that decides if a column has the button that
   adds an item. The function takes a map with the `:column-value` of the column.
   See `add-item`."
  [{:keys [entity-type pipeline label-key]}]
  (fn [{:keys [column-value]}]
    (add-item {:entity-type  entity-type
               :pipeline     pipeline
               :label-key    label-key
               :column-value column-value})))
